import { Input } from 'almanac-ui/TextInputField/Input'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { LinkExternal, Trash2 } from 'blaze-ui/icons'
import Styles from './WebsiteInput.module.scss'
import useOpenWindowSafely from 'hooks/useOpenWindowSafely'
import { NewWebsite } from '../BrandKitMultiplePagesForm'

interface WebsiteInputProps {
  website: NewWebsite
  index: number
  onRemoveWebsite: (index: number) => void
  setWebsites: (url: string) => void
}

export const WebsiteInput = ({ website, index, onRemoveWebsite, setWebsites }: WebsiteInputProps) => {
  const openWindowSafely = useOpenWindowSafely()

  return (
    <div className={Styles.website}>
      <Input
        id={`website-${index}`}
        name={`website-${index}`}
        value={website.url}
        placeholder="Enter other URL from your business website..."
        size="lg"
        autoCorrect="off"
        onChange={(e) => {
          if (e.target.value.length === 0) {
            onRemoveWebsite(index)
            return
          }

          setWebsites(e.target.value)
        }}
      />
      <IconButton
        variant="editor"
        icon={LinkExternal}
        size="lg"
        onPress={() => openWindowSafely(website.url.includes('http') ? website.url : `https://${website.url}`)}
        aria-label="link"
      />
      <IconButton variant="editor" icon={Trash2} size="lg" onPress={() => onRemoveWebsite(index)} aria-label="delete" />
    </div>
  )
}
